module.exports = "/static/assets/a662913c45d963c9548f434c825634b7.png";